import { useCallback } from 'react'
import { useAuthContext } from 'shared/components/AuthContext'
import { useHidePasswordPolicyWarning } from 'shared/components/PasswordPolicyContext'
import { ItemTag, resetViewerMode } from 'shared/utils'
import { clearSharedAuthTime } from 'shared/session/utils/sharedAuthTime'

export const useSignOut = () => {
  const { auth } = useAuthContext()
  const hidePasswordPolicyWarning = useHidePasswordPolicyWarning()

  return useCallback(async () => {
    try {
      await auth?.signOut()
    } finally {
      hidePasswordPolicyWarning?.()
      resetViewerMode()
      localStorage.removeItem(ItemTag.CUSTOM_CREDENTIALS_HISTORY)
      clearSharedAuthTime()
    }
  }, [auth, hidePasswordPolicyWarning])
}
